import { renderWithResolver } from '@cinch-nx/landing-ui-shared'
import { GenericContentWithImageSection } from '../../types/store-hub'
import { ContentWithImageSection } from '../content-with-image-section'
import styles from './how-stores-work.module.css'

export const HowStoresWork = ({
  howStoresWork,
}: {
  howStoresWork: GenericContentWithImageSection[]
}) => (
  <section className={styles.howStoresWork}>
    {howStoresWork.map((section) => (
      <ContentWithImageSection
        key={section.title}
        title={section.title}
        body={renderWithResolver(section.body)}
        image={section.image}
      />
    ))}
  </section>
)
